import { TRevenueSnapshotKeys } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import { IRevenue } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

interface IIsQuartersSumEqualYearResult {
  keyValue: TRevenueSnapshotKeys
  yearField: keyof IRevenue
  quarterFields: (keyof IRevenue)[]
  data: IRevenue[]
}

interface IQuartersIsInconsistency {
  keyValue: TRevenueSnapshotKeys
  yearField: keyof IRevenue
  quarterFields: (keyof IRevenue)[]
}

const reduceFn = (data: IRevenue[], keyValue: string) => (acc: number, cur: keyof IRevenue) => {
  const found = data.find((el) => el.Key === keyValue)
  return acc + Number(found?.[cur] || 0)
}

const isQuartersSumEqualYearResult = ({
  quarterFields,
  data,
  keyValue,
  yearField,
}: IIsQuartersSumEqualYearResult) => {
  const quartersSum = quarterFields.reduce(reduceFn(data, keyValue), 0)
  const yearResult = data.find((el) => el.Key === keyValue)
  return Number(quartersSum.toFixed(2)) === Number(Number(yearResult?.[yearField]).toFixed(2))
}

export const quartersIsInconsistency =
  ({ keyValue, yearField, quarterFields }: IQuartersIsInconsistency) =>
  (data: IRevenue[]) => {
    return !isQuartersSumEqualYearResult({ keyValue, yearField, quarterFields, data })
  }
